const Webview = {
  "options": {
    "data": {
      "url": {
        "type": "Text"
      }
    },
    "customization": {
      "isShowWebNavigators": {
        "type": "Radio",
        "order": 1,
        "data": {
          "direction": "row",
          "radioOptions": ["show", "notShow"]
        }
      }
    }
  },
  "variants": [
    {
      "id": "Webview_1",
      "name": "Webview_1",
      "type": "Webview",
      "data": {
        "url": ""
      },
      "customization": {
        "isShowWebNavigators": "show"
      },
      "variantData": {},
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Webview_1.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    }
  ]
}

 export default Webview